import React, { useMemo } from 'react';
import { View, StyleSheet } from 'react-native';
import { CommonProperties, CommonStyles, Color } from '../../styles';
import BaseText from '../BaseText';

export const SUCCESS = 'success';
export const WARNING = 'warning';
export const INFO = 'info';
export const ERROR = 'error';

const statusColor = StyleSheet.create({
  boxSuccess: {
    borderColor: Color.corporate,
  },
  boxWarning: {
    borderColor: '#ff8700',
  },
  boxError: {
    borderColor: '#ba1d1a',
  },
  boxInfo: {
    borderColor: Color.primary,
  },
  textSuccess: {
    color: Color.corporate,
  },
  textWarning: {
    color: '#ff8700',
  },
  textError: {
    color: '#ba1d1a',
  },
  textInfo: {
    color: Color.primary,
  },
  status: {
    borderColor: 'black',
    borderWidth: 1,
    ...CommonProperties.py1,
    ...CommonProperties.px3,
    ...CommonProperties.borderRadius3,
  },
});

const getStatusColor = (status) => {
  switch (status) {
    case SUCCESS:
      return {
        box: statusColor.boxSuccess,
        text: statusColor.textSuccess,
      };
    case WARNING:
      return {
        box: statusColor.boxWarning,
        text: statusColor.textWarning,
      };
    case ERROR:
      return {
        box: statusColor.boxError,
        text: statusColor.textError,
      };
    case INFO:
      return {
        box: statusColor.boxInfo,
        text: statusColor.textInfo,
      };
    default:
      return {};
  }
};

const TripStatus = ({ label, status }) => {
  const statusStyle = useMemo(() => getStatusColor(status), [status]);

  return (
    <View style={[statusColor.status, statusStyle.box]}>
      <BaseText style={[CommonStyles.xSmall, statusStyle.text]}>{label}</BaseText>
    </View>
  );
};

export default TripStatus;
